export default __webpack_public_path__ + "static/media/footerBackground.2441a5d8.svg";